import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  orderDetailsCta: {
    event_name: 'account_cta',
    event_category: 'account',
    event_action: 'click',
    event_label: null, // view details/view item
  },

  profileUpdate: {
    event_name: 'profile_update',
    event_category: 'account',
    event_action: 'profile update',
    event_label: null, // name/email/birthday/password
  },
};

function trackAccountProfile(_: string, eventData: IDataLayer = {}) {
  const profileElem = document.querySelectorAll('.fill-header-fg');
  profileElem.forEach((elemSelector) => {
    elemSelector.addEventListener('click', () => {
      const orderCTA = elemSelector.textContent || '';
      eventData.event_label = orderCTA;
      tealium.evtLink({ ...defaultData['orderDetailsCta'], ...eventData });
    });
  });
}

const orderDetailsbuttons = document.querySelectorAll(
  '.gap-3 .edl-button__label, .justify-between .edl-link__label',
);
const eventData: IDataLayer = {};
orderDetailsbuttons.forEach((orderDetail) => {
  orderDetail.addEventListener('click', () => {
    const orderCTA = orderDetail.textContent || '';
    eventData.event_label = orderCTA;
    tealium.evtLink({ ...defaultData['orderDetailsCta'], ...eventData });
  });
});

const profileUpdatebuttons = document.querySelectorAll(
  '.justify-end .edl-button__label',
);
profileUpdatebuttons.forEach((profileUpdate) => {
  profileUpdate.addEventListener('click', () => {
    const profileHeading =
      profileUpdate?.closest('.py-6')?.getAttribute('data-text-heading') || '';
    eventData.event_label = profileHeading;
    tealium.evtLink({ ...defaultData['profileUpdate'], ...eventData });
  });
});

registerAnalyticsEventHandler('accountProfile', trackAccountProfile);
